export default __webpack_public_path__ + "static/media/story-background.be987a2c.png";